import {Link} from "react-router-dom";
import Insta1 from "../../assets/img/insta1.webp";
import Insta2 from "../../assets/img/insta2.webp";
import Insta3 from "../../assets/img/insta3.webp";
import Insta4 from "../../assets/img/insta4.webp";
import Mastercard from "../../assets/img/mastercard.webp"
import Visa from "../../assets/img/visa.png"
import React from "react";
import { useTranslation, Trans } from "react-i18next";

import { FaFacebookF, FaInstagram, FaSnapchatGhost } from "react-icons/fa";
const Footer = () => {

    const { t } = useTranslation();
    return ( 
        <footer className="pb-0">
            <div className="site-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-5 d-flex flex-column mb-4 pe-md-5">
                            <h3 className="text-md-start">{t('Akad Gate Pharmacy')}</h3>
                            <div>
                                <p className="footer-paragraph text-md-start text-white">
                                    {t('Welcome to AKAD Gate Pharmacy, where our commitment to genuine products and exceptional service has been the cornerstone of our mission since our establishment in 2016 in Ankawa. Over the years, we have proudly served our community with integrity, providing maximum service to our patients and customers.')}
                                </p>
                                <ul
                                    className="d-flex gap-2 align-items-center list-unstyled quick-info mb-0"
                                >
                                    <li>
                                        <a
                                            href="https://www.facebook.com/AkadPharmacy"
                                            target="_blank"
                                            aria-label="Facebook"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon icon-tabler icon-tabler-brand-meta"
                                                width="28"
                                                height="28"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="#2c3e50"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                <path
                                                    d="M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z"
                                                />
                                                <path
                                                    d="M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.instagram.com/akad_gate_pharmacy"
                                            target="_blank"
                                            aria-label="Instagram"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon icon-tabler icon-tabler-brand-instagram"
                                                width="28"
                                                height="28"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="#2c3e50"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                <path
                                                    d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
                                                />
                                                <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/>
                                                <path d="M16.5 7.5l0 .01"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.snapchat.com/add/akadgate-pharma?share_id=ZltNbNTJU2I&locale=en-US"
                                            target="_blank"
                                            aria-label="Snapchat"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon icon-tabler icon-tabler-brand-snapchat"
                                                width="28"
                                                height="28"
                                                viewBox="0 0 24 24"
                                                strokeidth="1.5"
                                                stroke="#2c3e50"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                <path
                                                    d="M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div
                                className="flex-fill d-flex justify-content-center justify-content-md-start align-items-center align-items-md-end mt-4 mt-md-0"
                            >
                                <img src={Mastercard} alt="Mastercard"/>
                                <img src={Visa} alt="Visa"/>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4">
                            <h3 className="text-md-start">{t('Quick Links')}</h3>
                            <ul className="quick-links list-unstyled text-md-start">
                                <li>
                                    <a href="index.html" className="to-top-footer text-white">{t('home')}</a>
                                </li>
                                <li>
                                    <a className="text-white" href="shop.html">{t('shop')}</a>
                                </li>
                                <li>
                                    <a className="text-white" href="aboutus.html">{t('about us')}</a>
                                </li>
                                <li>
                                    <a className="text-white" href="#get-in-touch-section">{t('contact us')}</a>
                                </li>
                                <li>
                                    <a className="text-white" href="login.html">{t('login')}</a>
                                </li>
                                <li>
                                    <a className="text-white" href="register.html">{t('register')}</a>
                                </li>
                                <li>
                                    <a className="text-white" href="termsandconditions.html" target="_blank"
                                    >{t('Terms and Conditions')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.walgreens.com/topic/help/generalhelp/privacyandsecurity.jsp?foot=security"
                                        target="_blank"
                                        aria-label="Privacy Policy"
                                        className="text-white"
                                    >
                                        {t('Privacy Policy')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4 mb-4">
                            <h3 className="gallery-heading text-md-start">{t('Instagram')}</h3>
                            <div className="gallery d-flex justify-content-center justify-content-md-start ">
                                <div>
                                    <a
                                        href="https://www.instagram.com/p/CyGNa3JIMQF/"
                                        className="footer-left"
                                        target="_blank"
                                        aria-label="Instagram"
                                    >
                                        <img
                                            src={Insta1}
                                            alt="Image"
                                            height="142"
                                            width="142"
                                            className="img-fluid"
                                        />
                                    </a>
                                    <a
                                        href="https://www.instagram.com/p/CrqiVNnoVqh/"
                                        className="footer-left"
                                        target="_blank"
                                        aria-label="Instagram"
                                    >
                                        <img
                                            src={Insta2}
                                            alt="Image"
                                            height="142"
                                            width="142"
                                            className="img-fluid"
                                        />
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="https://www.instagram.com/p/CvRuhbfIoi_/"
                                        className="footer-right"
                                        target="_blank"
                                        aria-label="Instagram"
                                    >
                                        <img
                                            src={Insta3}
                                            alt="Image"
                                            height="142"
                                            width="142"
                                            className="img-fluid"
                                        />
                                    </a>
                                    <a
                                        href="https://www.instagram.com/p/CsCGdYYIaLC/"
                                        className="footer-right"
                                        target="_blank"
                                        aria-label="Instagram"
                                    >
                                        <img
                                            src={Insta4}
                                            alt="Image"
                                            height="142"
                                            width="142"
                                            className="img-fluid"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className="col-12">
                            <div className="copyright pb-4 text-center">
                                Copyright &copy;2023 All rights reserved | Developed by
                                <a href="#" className="ms-sm-1 text-white">{t('Target Technology')} </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
export default Footer;